module.exports = __webpack_public_path__ + "static/img/图片7.cb4d5994.png";